import * as styles from "./CentreMapOverlayCard.module.scss";

import React from "react";
import { Colours } from "../../../utils/colours";
import { Arrow } from "../../common/Icons";
import LinkNoStyle from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export interface CentreMapOverlayCardProps {
	imgUrl: string;
	url: string;
	centreName: string;
	city: string;
	postCode: string;
	phoneNumber: string;
	googleMapsUrl: string;
	distance?: number;
}

export const CentreMapOverlayCard: React.FC<CentreMapOverlayCardProps> = ({
	imgUrl,
	url,
	centreName,
	city,
	distance,
}) => {
	return (
		<div className={styles.centrecardcontainer}>
			<div className={styles.centrecardimagewrapper}>
				<ProcessedImage
					className={styles.centrecardimage}
					src={imgUrl}
					alt={centreName}
					dimensions="160x120"
					width={160}
					height={120}
					loading={"lazy"}
				/>
			</div>
			<div className={styles.middlecontainer}>
				<div className={styles.centrename}>{centreName}</div>
				<div className={styles.centrelocation}>{city}</div>
			</div>
			<div className={styles.rightcontainer}>
				<div className={styles.distance}>
					{distance ? `${distance.toFixed(1)} miles` : ""}
				</div>
				<LinkNoStyle to={url} aria-label={`Visit ${centreName}`}>
					<Arrow
						withBorder={false}
						rotation={180}
						fill={Colours.SUNSHINE_YELLOW}
					/>
				</LinkNoStyle>
			</div>
		</div>
	);
};

export default CentreMapOverlayCard;
